import React from 'react';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { IconButton, SxProps } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { colors } from 'common/constants';

type BaseDialogProps = DialogProps & {
    children?: React.ReactNode;
    footer?: React.ReactNode;
    sxContent?: SxProps;
};

const BaseDialog: React.FC<BaseDialogProps> = ({
    open,
    footer,
    scroll,
    title,
    sxContent,
    ...props
}) => {
    return (
        <React.Fragment>
            <Dialog
                {...props}
                open={open}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                maxWidth={props.maxWidth}
                onClose={props.onClose}
                sx={{
                    '& .MuiDialog-paper': {
                        borderRadius: ['20px'],
                    },
                }}
            >
                {props.onClose && (
                    <IconButton
                        onClick={() => {
                            props.onClose && props.onClose({}, 'escapeKeyDown');
                        }}
                        aria-label="close"
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            zIndex: 100,
                        }}
                    >
                        <CloseIcon sx={{ fontSize: [24, 42] }} />
                    </IconButton>
                )}

                <DialogContent
                    dividers={!!footer}
                    sx={{ padding: 0, ...sxContent }}
                >
                    <DialogContentText
                        id="scroll-dialog-description"
                        tabIndex={-1}
                    >
                        {title && (
                            <DialogTitle
                                sx={{
                                    fontSize: '35px',
                                    fontWeight: '700',
                                    textAlign: 'center',
                                    lineHeight: '48.41px',
                                    color: `${colors.main}`,
                                    whiteSpace: 'pre-line',
                                }}
                                id="scroll-dialog-title"
                            >
                                {title}
                            </DialogTitle>
                        )}
                        {props.children}
                    </DialogContentText>
                </DialogContent>
                {footer && (
                    <DialogActions sx={{ padding: '1rem 1.5rem 1rem 1.5rem' }}>
                        {footer}
                    </DialogActions>
                )}
            </Dialog>
        </React.Fragment>
    );
};

export default BaseDialog;
